import React from 'react';
import { useTranslation } from 'react-i18next';
import '@flaticon/flaticon-uicons/css/all/all.css';
import '@fortawesome/fontawesome-free/css/all.min.css';

interface Props {
  agencyDataAddress: string;
  agencyDataCity: string;
  agencyDataComuneCapoluogo: boolean;
  agencyDataProvinciaSigla: string;
  agencyDataEmail: string;
  agencyDataEmailShow: boolean;
  agencyDataPhone1: string;
  agencyDataPhone2?: string;
  agencyDataInternationalPrefix: string;
  agencyDataMobile?: string;
  agencyDataMobile2?: string;
  agencyDataFax?: string;
  agencySocialShow?: boolean;
  agencyDataWhatsapp?: string;
  agencyDataFacebook?: string;
  agencyDataInstagram?: string;
  agencyDataTwitter?: string;
  agencyDataLinkedin?: string;
  agencyDataPinterest?: string;
  agencyDataYoutube?: string;
  agencyDataTikTok?: string;
  agencyDataThreads?: string;
}

export const ContactAddress: React.FC<Props> = ({
  agencyDataAddress,
  agencyDataCity,
  agencyDataComuneCapoluogo,
  agencyDataProvinciaSigla,
  agencyDataEmail,
  agencyDataEmailShow,
  agencyDataPhone1,
  agencyDataPhone2,
  agencyDataInternationalPrefix,
  agencyDataMobile,
  agencyDataMobile2,
  agencyDataFax,
  agencySocialShow,
  agencyDataWhatsapp,
  agencyDataFacebook,
  agencyDataInstagram,
  agencyDataTwitter,
  agencyDataLinkedin,
  agencyDataPinterest,
  agencyDataYoutube,
  agencyDataTikTok,
  agencyDataThreads
}) => {
  const { t } = useTranslation();

  return (
    
    <div className="contact-address widget">

      <div className="widget-title">
        <h4>{t('widgets.contacts.title') || "" }</h4>
      </div>

      {/* Address */}
      {agencyDataAddress ? (
      <div className="">
        <div className="contact-address-icon">
          <i className="flaticon-map text-primary font-xlll"></i>
        </div>
        <div className="">
          <h6>{t('widgets.contacts.addressLabel')}</h6>
          <p>
            {agencyDataAddress}<br />
            {agencyDataCity} {agencyDataComuneCapoluogo ? '' : ` (${agencyDataProvinciaSigla})`}
          </p>
        </div>
      </div>
      ) : null}

      {/* Email */}
      {agencyDataEmailShow && agencyDataEmail ? (
        <div className="">
          <div className="contact-address-icon">
            <i className="flaticon-email text-primary font-xlll"></i>
          </div>
          <div className="">
            <h6>{t('widgets.contacts.emailLabel')}</h6>
            <p><a href={`mailto:${agencyDataEmail}`} title={t('widgets.contacts.emailTitle') || 'Invia una email'}>{agencyDataEmail}</a></p>
          </div>
        </div>
      ) : null}

      {/* Phone */}
      {agencyDataPhone1 && (
        <div>
          <div className="contact-address-icon">
          <i className="flaticon-telephone text-primary font-xlll"></i>
          </div>
          <div className="">
            <h6>{t('widgets.contacts.phoneLabel')}</h6>
            <p>
            <a
                title={t('widgets.contacts.phoneTitle') || "Telefono"}
                href={`tel:${agencyDataInternationalPrefix}${agencyDataPhone1}`}
              >
                {agencyDataInternationalPrefix} {agencyDataPhone1}
              </a>
              {agencyDataPhone2 && (
                <> | <a title={t('widgets.contacts.phoneTitle') || "Telefono"} href={`tel:${agencyDataInternationalPrefix}${agencyDataPhone2}`}>{agencyDataInternationalPrefix} {agencyDataPhone2}</a></>
              )}
            </p>
          </div>
        </div>
      )}

      {/* Mobile */}
      {agencyDataMobile && (
        <div>
          <div className="contact-address-icon">
            <i className="flaticon-call text-primary font-xlll"></i>
          </div>
          <div className="">
            <h6>{t('widgets.contacts.mobileLabel')}</h6>
            <p>
              <a title={t('widgets.contacts.mobileTitle') || "Cellulare"} href={`tel:${agencyDataInternationalPrefix}${agencyDataMobile}`}>
                {agencyDataInternationalPrefix} {agencyDataMobile}
              </a>
              {agencyDataMobile2 && (
                <> | <a title={t('widgets.contacts.mobileTitle') || "Cellulare"} href={`tel:${agencyDataInternationalPrefix}${agencyDataMobile2}`}>{agencyDataInternationalPrefix} {agencyDataMobile2}</a></>
              )}
            </p>
          </div>
        </div>
      )}

      {/* Fax */}
      {agencyDataFax && (
        <div className="d-flex mb-3">
          <div className="contact-address-icon">
            <i className="flaticon-fax text-primary font-xlll"></i>
          </div>
          <div>
            <h6>{t('widgets.contacts.faxLabel')}</h6>
            <p>{agencyDataInternationalPrefix} {agencyDataFax}</p>
          </div>
        </div>
      )}

      {/* Social Media */}
      {agencySocialShow && (agencyDataWhatsapp || agencyDataFacebook || agencyDataInstagram || agencyDataTwitter || agencyDataLinkedin || agencyDataPinterest) && (
        <div className="social-icon-02">
          <div>
            <h6 className="mr-3">Social:</h6>
            <ul className="list-unstyled mb-0 list-inline">
              {agencyDataWhatsapp && (
                <li style={{ marginRight: "0.2vw" }}>
                  <a
                    title="Whatsapp"
                    target="_blank"
                    className="whatsapp"
                    href={`https://api.whatsapp.com/send?phone=${agencyDataWhatsapp}`}
                    rel="noopener noreferrer"
                  >
                    <i className="fab fa-whatsapp"></i>
                  </a>
                </li>
              )}
              {agencyDataFacebook && (
                <li style={{ marginRight: "0.2vw" }}>
                  <a href={agencyDataFacebook} target="_blank" title="Facebook" rel="noopener noreferrer">
                    <i className="fab fa-facebook-f"></i>
                  </a>
                </li>
              )}
              {agencyDataInstagram && (
                <li style={{ marginRight: "0.2vw" }}>
                  <a href={agencyDataInstagram} target="_blank" title="Instagram" rel="noopener noreferrer">
                    <i className="fab fa-instagram"></i>
                  </a>
                </li>
              )}
              {agencyDataTwitter && (
                <li style={{ marginRight: "0.2vw" }}>
                  <a href={agencyDataTwitter} target="_blank" title="Twitter" rel="noopener noreferrer">
                    <i className="fab fa-twitter"></i>
                  </a>
                </li>
              )}
              {agencyDataLinkedin && (
                <li style={{ marginRight: "0.2vw" }}>
                  <a href={agencyDataLinkedin} target="_blank" title="LinkedIn" rel="noopener noreferrer">
                    <i className="fab fa-linkedin"></i>
                  </a>
                </li>
              )}
              {agencyDataPinterest && (
                <li>
                  <a href={agencyDataPinterest} target="_blank" title="Pinterest" rel="noopener noreferrer">
                    <i className="fab fa-pinterest"></i>
                  </a>
                </li>
              )}
              {agencyDataYoutube && (
                <li>
                  <a href={agencyDataYoutube} target="_blank" title="Youtube" rel="noopener noreferrer">
                    <i className="fab fa-youtube"></i>
                  </a>
                </li>
              )}
              {agencyDataTikTok && (
                <li>
                  <a href={agencyDataTikTok} target="_blank" title="TikTok" rel="noopener noreferrer">
                    <i className="fab fa-tiktok"></i>
                  </a>
                </li>
              )}
              {agencyDataThreads && (
                <li>
                  <a href={agencyDataThreads} target="_blank" title="Threads" rel="noopener noreferrer">
                    <i className="fab fa-threads"></i>
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>
      )}
    </div>
  );
};

export default ContactAddress;